import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { getCollectionShowcasePageData } from '@components/CollectionShowcasePage/CollectionShowcasePage.utils'
import { lazyImport } from '@helpers'
import {
  withApollo,
  withErrorBoundary,
  withI18next,
  withStaffPickImage,
  withSuspense,
  withTheme,
} from '@hocs'

const { CollectionShowcasePage } = lazyImport(
  () => import('@components/CollectionShowcasePage/CollectionShowcasePage'),
  'CollectionShowcasePage',
)

const collectionShowcasePageEl = document.getElementById(
  'collection-showcase-page',
)
const collectionShowcasePage = collectionShowcasePageEl
  ? getCollectionShowcasePageData()
  : null

export const renderCollectionShowcasePageApp = () => {
  if (collectionShowcasePageEl && collectionShowcasePage) {
    const CollectionShowcasePageApp = () => (
      <CollectionShowcasePage {...collectionShowcasePage} />
    )

    const CollectionShowcasePageWrapper = pipe(
      CollectionShowcasePageApp,
      withSuspense,
      withStaffPickImage,
      withI18next,
      withApollo,
      withErrorBoundary,
      withTheme,
    )

    ReactDOM.createRoot(collectionShowcasePageEl).render(
      <CollectionShowcasePageWrapper />,
    )
  }
}
